import { render, staticRenderFns } from "./radioOn.vue?vue&type=template&id=5f5fa500&"
import script from "./radioOn.vue?vue&type=script&lang=ts&"
export * from "./radioOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports